/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default class StickyToolbar extends React.Component {
  render() {
    return (
      <>
        <ul
          className="kt-sticky-toolbar"
          style={{
            margin: "0",
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <OverlayTrigger
            placement="left"
            overlay={
              <Tooltip className="tooltip-dark" id="layout-tooltip">
                Online Help
              </Tooltip>
            }
          >
            <li
              className="kt-sticky-toolbar__item kt-sticky-toolbar__item--light"
              data-placement="left"
            >
              <a
                href="http://knowledge.invifo.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-question-circle" />
              </a>
            </li>
          </OverlayTrigger>

          <OverlayTrigger
            placement="left"
            overlay={
              <Tooltip className="tooltip-dark" id="guidances-tooltip">
                Guidances
              </Tooltip>
            }
          >
            <li
              className="kt-sticky-toolbar__item kt-sticky-toolbar__item--light"
              data-placement="left"
            >
              <Link to="/common/guidances">
                <i className="fas fa-book-reader" />
              </Link>
            </li>
          </OverlayTrigger>
        </ul>
      </>
    );
  }
}
